import * as yup from 'yup';
export const taxFormParam = yup.object({
    merchantAccountId: yup.number().min(1).required(),
    formType: yup.string().default(() => '1099-K'),
    year: yup.number().default(() => new Date().getFullYear()),
});
//# sourceMappingURL=taxForm.js.map